import versionContainer from '../../package.json';

const { version: appVersion } = versionContainer;

export function getCurrentVersion() {
  if (!appVersion || !appVersion.match(/^\d+\.\d+\.\d+$/)) {
    console.error('Invalid package version:', appVersion);
    if (process.env.NODE_ENV === 'development') {
      throw new Error('Invalid package version');
    }
    return '0.0.1-dev';
  }
  return appVersion;
}
